import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ComponentsModule} from '../../../components/components.module';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {InputTextModule} from 'primeng/inputtext';
import {BookingStatusComponent} from './booking-status.component';

@NgModule({declarations: [BookingStatusComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule,
    ComponentsModule, ButtonModule, TableModule, DialogModule, ConfirmDialogModule, InputTextModule]})
export class BookingStatusModule {}
